import { render, staticRenderFns } from "./OutrasSettings.vue?vue&type=template&id=7dfa29f7"
import script from "./OutrasSettings.vue?vue&type=script&lang=js"
export * from "./OutrasSettings.vue?vue&type=script&lang=js"
import style0 from "./OutrasSettings.vue?vue&type=style&index=0&id=7dfa29f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports